module.exports = __webpack_public_path__ + "media/img/favicon-16x16-7183f1b81b990e7e8a509a9536b6ab05.png";